import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from './feedback.graphql';
import * as fromActions from './feedback.actions';
import {map, switchMap} from 'rxjs';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from '../../reducers';
import {getMyServiceFeedbackComplaints} from "./feedback.actions";


@Injectable()
export class FeedbackEffects {
  createFeedback$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFeedback),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.createFeedbackComplaint,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.upsertFeedback({ feedback: result?.data }));
              this.notificationService.successMessage(result?.response?.message);
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  transferFeedbackToEmrejesho$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.transferFeedbackToEmrejesho),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.TRANSFER_FEEDBACK_TO_EMREJESHO,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while transfering feedback to e-Mrejesho'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFeedback({ feedback: result?.data }));
              this.notificationService.successMessage('Successfully Transfered to e-Mrejesho');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  respondToServiceFeedback$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.respondToServiceFeedback),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.RESPOND_TO_SERVICE_FEEDBACK,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while transfering Respond to Services FeedBack'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.notificationService.successMessage('Successfully Respond to Services FeedBack');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  feedbackFollowupFromEmrejesho$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.feedbackFollowupFromEmrejesho),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.FEEDBACK_FOLLOWUP_FROM_EMREJESHO,
        variables: {
          feedbackUniqueId: action?.feedbackUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFeedback({ feedback: result?.data }));
              this.notificationService.successMessage('Followup successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  getAllFeedbacks$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllFeedbacks),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.getServiceFeedbackComplaints,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching feedbacks'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]

            console.log(result)
            result?.response?.status ? this.store.dispatch(
              fromActions.loadFeedbacks({ feedbacks: result?.data }))
             : []
          }
        })
      );
    })
  ), { dispatch: false });

  getMyServiceFeedbackComplaints$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getMyServiceFeedbackComplaints),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.getMyServiceFeedbackComplaints,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching feedbacks'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(
                fromActions.loadFeedbacks({ feedbacks: result?.data }))
              : []
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
